import { Button } from "@mui/material";

export default function KizSellStatusButton({ it, onSetSold }) {
  return (
    <div style={{ marginTop: 8 }}>
      <div
        style={{
          fontSize: 12,
          color: "#6b7280",
          marginBottom: 4,
        }}
      >
        Статус продажи КИЗ
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <Button
          onClick={() => onSetSold?.(it, "sold")}
          variant={
            it.withdrawal_status === "on_balance" ? "contained" : "outlined"
          }
        >
          Продан
        </Button>
      </div>
    </div>
  );
}
